import { useState, useEffect } from "react";
import Projectcard from "./Projectcard";

const Projects = () => {
    const [projects, setProjects] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProjects = async () => {
          setError(null);
          try {
            const response = await fetch("/projects.json");
            if (!response.ok) {
              throw new Error(`서버 응답 에러: ${response.status}`);
            }
            const data = await response.json();
            setProjects(Array.isArray(data) ? data : []);
          } catch (error) {
            console.log(error);
            setError(error.message);
          } finally {
            setLoading(false);
          }
        };
        fetchProjects();
    }, []);

    return (
        <div>
            <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-start text-center md:text-left">
                <div className="w-full">
                    <h2 className="text-3xl font-bold mb-4">프로젝트</h2>
                    <p className="mb-4">제가 진행한 프로젝트의 목록입니다. 프로젝트는 수시로 업데이트됩니다.</p>
                    <div className="flex-wrap justify-center mt-4 mb-8 grid grid-cols-1 md:grid-cols-3 gap-8">
                        {loading && <p>프로젝트 목록을 불러오는 중입니다..</p>}
                        {error && <p>프로젝트를 불러오는 중 오류가 발생했습니다: {error}</p>}
                        {!loading && !error && projects.length === 0 && <p>등록된 프로젝트가 없습니다.</p>}
                        {!loading && !error && Array.isArray(projects) && [...projects]
                            .sort((a, b) => a.isFeatured === b.isFeatured
                              ? b.id - a.id
                              : (a.isFeatured ? -1 : 1)
                            )
                            .map(project => (
                            <Projectcard key={project.id} id={project.id} name={project.title} description={project.headline} image={project.imgURL} isVerified={project.isVerified} featured={project.isFeatured} stacks={project.stacks} />
                        ))}
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Projects;